import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { CompanyEmployeeService } from '../../Services/CompanyEmployee/company-employee.service';
import { Injectable } from '@angular/core';
import { GetAllCompanyEmployes, ECompanyEmployeeActions, GetAllCompanyEmployesSuccess,
     GetAllCompanyEmployesError, AddCompanyEmployee, GetAddCompanyEmployeeSuccess, GetAddCompanyEmployeeError,
     EditCompanyEmployee, GetEditCompanyEmployeeSuccess, GetEditCompanyEmployeeError, GetEmployeesByRole,
      LoginCompanyEmployee, LoginCompanyEmployeeSuccess, LoginCompanyEmployeeError, SendLinkCompanyEmployeeFrgtPswd, SendLinkCompanyEmployeeFrgtPswdSuccess, SendLinkCompanyEmployeeFrgtPswdError, CompanyEmployeeResetPassword, CompanyEmployeeResetPasswordSuccess, CompanyEmployeeResetPasswordError, GetAllCompanyEmployesByRoleSuccess, GetAllCompanyEmployesByRoleError, GetEmployeesToAddMasterUser,
       GetEmployeesToAddMasterUserSuccess, SetCompanyEmployeesErrorMsg, RemoveCmpyUsers, GetEmployeesToAddSubUser, RemoveUserRoles, GetUpdatedRoleUser, GetUpdatedRoleUserSuccess, GetUpdatedRoleUserError, GetAllSalesControllerUsers, GetAllWarehouseControllerUsers, GetAllWarehouseandProductionControllerUsers } from '../actions/companyEmployee.action';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from '../../Services/User/user.service';


@Injectable()
export class CompanyEmployeeEffects {


    getallcompanyemployes$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllCompanyEmployes>(ECompanyEmployeeActions.GetAllCompanyEmployes),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyEmployeeService.getAllCompanyEmployes(payload).pipe(
                map((result: any) => {
                    return new GetAllCompanyEmployesSuccess(result);
                }),
                catchError((err) => of(new GetAllCompanyEmployesError(err)))
            );
        })));

    getaddcompanyEmployee$ = createEffect(() => this.actions$.pipe(
        ofType<AddCompanyEmployee>(ECompanyEmployeeActions.AddCompanyEmployee),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyEmployeeService.addCompanyEmployee(payload).pipe(
                map((result: any) => {
                    return new GetAddCompanyEmployeeSuccess(result);
                }),
                catchError((err) => of(new GetAddCompanyEmployeeError(err)))
            );
        })));

    geteditcompanyEmployee$ = createEffect(() => this.actions$.pipe(
        ofType<EditCompanyEmployee>(ECompanyEmployeeActions.EditCompanyEmployee),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyEmployeeService.addCompanyEmployee(payload).pipe(
                map((result: any) => {
                    return new GetEditCompanyEmployeeSuccess(result);
                }),
                catchError((err) => of(new GetEditCompanyEmployeeError(err)))
            );
        })));

    getcompanyEmployeesByRoles$ = createEffect(() => this.actions$.pipe(
        ofType<GetEmployeesByRole>(ECompanyEmployeeActions.GetEmployeesByRole),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyEmployeeService.getCompanyEmployeesByRoles(payload).pipe(
                map((result: any) => {
                    return new GetAllCompanyEmployesByRoleSuccess(result);
                }),
                catchError((err) => of(new GetAllCompanyEmployesByRoleError(err)))
            );
        })));

    getLoginCompanyEmployees$ = createEffect(() => this.actions$.pipe(
        ofType<LoginCompanyEmployee>(ECompanyEmployeeActions.LoginCompanyEmployee),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyEmployeeService.loginCompanyEmployee(payload).pipe(
                map((result: any) => {
                    // result['user_role'] = "Employee"
                    this.userService.setUserdetails(result);
                    return new LoginCompanyEmployeeSuccess(result);
                }),
                catchError((err) => of(new LoginCompanyEmployeeError(err)))
            );
        })));

        getUpdatedUserRole$ = createEffect(() => this.actions$.pipe(
            ofType<GetUpdatedRoleUser>(ECompanyEmployeeActions.GetUpdatedRoleUser),
            map(action => action.payload),
            switchMap((payload : any) => {
                return this.companyEmployeeService.getUpdatedRoleUser(payload).pipe(
                    map((result: any) => {
                        this.userService.setRoleUserdetails(result);
                        return new GetUpdatedRoleUserSuccess(result);
                    }),
                    catchError((err) => of(new GetUpdatedRoleUserError(err)))
                );
            })));

    getCompanyEmployeessendPasswordResetLink$ = createEffect(() => this.actions$.pipe(
        ofType<SendLinkCompanyEmployeeFrgtPswd>(ECompanyEmployeeActions.SendLinkCompanyEmployeeFrgtPswd),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyEmployeeService.comapanyEmployeeForgotPswdCheckUsername(payload).pipe(
                map((result: any) => {
                    return new SendLinkCompanyEmployeeFrgtPswdSuccess(result);
                }),
                catchError((err) => of(new SendLinkCompanyEmployeeFrgtPswdError(err)))
            );
        })));

    getCompanyEmployeesresetPassword$ = createEffect(() => this.actions$.pipe(
        ofType<CompanyEmployeeResetPassword>(ECompanyEmployeeActions.CompanyEmployeeResetPassword),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyEmployeeService.companyEmployeeResetPassword(payload).pipe(
                map((result: any) => {
                    return new CompanyEmployeeResetPasswordSuccess(result);
                }),
                catchError((err) => of(new CompanyEmployeeResetPasswordError(err)))
            );
        })));

    getEmployeesToAddMasterUser$ = createEffect(() => this.actions$.pipe(
        ofType<GetEmployeesToAddMasterUser>(ECompanyEmployeeActions.GetEmployeesToAddMasterUser),
        map(action => action.payload),
        mergeMap((payload : any) => this.companyEmployeeService.getEmployeesToAddMasterUser(payload)
        .pipe(map((result: any) => ({ type: '[CompanyEmployee] Set CompanyEmployee For Master User Success', payload: result })),
          catchError((err) => of({ type: '[CompanyEmployee] Set CompanyEmployee Error Msg', payload:err }))
        )
      )));

      getEmployeesToAddSubUser$ = createEffect(() => this.actions$.pipe(
          ofType<GetEmployeesToAddSubUser>(ECompanyEmployeeActions.GetEmployeesToAddSubUser),
          map(action => action.payload),
          mergeMap((payload : any) => this.companyEmployeeService.getEmployeesToAddMasterSubUser(payload)
          .pipe(map((result: any) => ({ type: '[CompanyEmployee] Get CompanyEmployee For Sub User Success', payload: result })),
            catchError((err) => of({ type: '[CompanyEmployee] Get CompanyEmployee For Sub User Error', payload:err }))
          )
        )));


    removeCmpyUsers$ = createEffect(() => this.actions$.pipe(
        ofType<RemoveCmpyUsers>(ECompanyEmployeeActions.RemoveCmpyUsers),
        map(action => action.payload),
        mergeMap((payload : any) => this.companyEmployeeService.removeCmpyUsers(payload)
        .pipe(map((result: any) => ({ type: '[CompanyEmployee] Get Remove Cmpy Users Success', payload: result })),
          catchError((err) => of({ type: '[CompanyEmployee] Get Remove Cmpy Users Error', payload:err }))
        )
      )));


      removeUserRoles$ = createEffect(() => this.actions$.pipe(
        ofType<RemoveUserRoles>(ECompanyEmployeeActions.RemoveUserRoles),
        map(action => action.payload),
        mergeMap((payload : any) => this.companyEmployeeService.removeUserRoles(payload)
       .pipe(map((result: any) =>({ type: '[CompanyEmployee] Get Remove User Roles Success', payload: result })),
          catchError((err) => of({ type: '[CompanyEmployee] Get Remove User Roles Error', payload:err }))
        )

      )));

      getAllSalesControllerusers$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllSalesControllerUsers>(ECompanyEmployeeActions.GetAllSalesControllerUsers),
        map(action => action.payload),
        mergeMap((payload : any) => this.companyEmployeeService.getAllSalesControllerUsers(payload)
       .pipe(map((result: any) =>({ type: '[CompanyEmployee] Get All Sales Controller users Success', payload: result })),
          catchError((err) => of({ type: '[] Get All Sales Controller users Error', payload:err }))
        )

      )));

      getAllWarehouseControllerusers$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllWarehouseControllerUsers>(ECompanyEmployeeActions.GetAllWarehouseControllerUsers),
        map(action => action.payload),
        mergeMap((payload : any) => this.companyEmployeeService.getAllWarehouseControllerUsers(payload)
       .pipe(map((result: any) =>({ type: '[CompanyEmployee] Get All Warehouse Controller users Success', payload: result })),
          catchError((err) => of({ type: '[] Get All Warehouse Controller users Error', payload:err }))
        )

      )));

      getAllWarehouseandProductionControllerusers$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllWarehouseandProductionControllerUsers>(ECompanyEmployeeActions.GetAllWarehouseandProductionControllerUsers),
        map(action => action.payload),
        mergeMap((payload : any) => this.companyEmployeeService.getAllWarehouseandProductionControllerUsers(payload)
       .pipe(map((result: any) =>({ type: '[CompanyEmployee] Get All Warehouse and Production Controller users Success', payload: result })),
          catchError((err) => of({ type: '[] Get All Warehouse and Production Controller users Error', payload:err }))
        )

      )));
    constructor( private actions$: Actions,
        private store: Store<IAppState>,
        private companyEmployeeService: CompanyEmployeeService,
        private userService: UserService,
    ){}
}
